var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "history_box" }, [
    _c("div", { staticClass: "photoHistory_box" }, [
      _c("div", { staticClass: "operation" }, [
        _c("span", { staticClass: "all unbind" }, [
          _c("i"),
          _vm._v(" "),
          _c("span", { attrs: { i18n: "history_all" } }, [
            _vm._v(_vm._s(_vm.$t("SelectAll"))),
          ]),
        ]),
        _c(
          "span",
          { staticClass: "delete unbind", attrs: { i18n: "history_delete" } },
          [_vm._v(_vm._s(_vm.$t("Delete")))]
        ),
        _c(
          "span",
          { staticClass: "clear unbind", attrs: { i18n: "history_clear" } },
          [_vm._v(_vm._s(_vm.$t("Clear")))]
        ),
      ]),
      _c("img", {
        staticClass: "load",
        attrs: { src: require("../assets/images/load.svg"), alt: "Load" },
      }),
      _c("div", { staticClass: "noHistory" }, [
        _c("img", {
          attrs: {
            src: require("../assets/images/no-history.svg"),
            alt: "No History",
          },
        }),
        _c("p", { attrs: { i18n: "no_history" } }, [
          _vm._v(_vm._s(_vm.$t("noHistory"))),
        ]),
      ]),
      _c("ul", { staticClass: "scroll_box" }),
    ]),
    _c("div", { staticClass: "maskTips1" }, [
      _c("div", { staticStyle: { "max-width": "500px" } }, [
        _c("i", {
          staticClass: "close",
          attrs: { onclick: "$('.maskTips1').hide()" },
        }),
        _c("img", { attrs: { src: require("../assets/tip.svg"), alt: "Tip" } }),
        _c("p", { staticClass: "errorListInfo" }),
        _c(
          "div",
          { staticClass: "errorList", staticStyle: { "text-align": "center" } },
          [_vm._v(" " + _vm._s(_vm.$t("tips.used_up")) + " ")]
        ),
        _c(
          "span",
          {
            staticClass: "btn btn_v1 errorListBtn_v1",
            on: { click: _vm.upgrade },
          },
          [_vm._v(_vm._s(_vm.$t("btn.tips_upgrade")))]
        ),
        _c(
          "span",
          {
            staticClass: "btn btn_v2 continue",
            staticStyle: { color: "#2473E8" },
            on: { click: _vm.downloadImg },
          },
          [_vm._v(_vm._s(_vm.$t("btn.continue_download")))]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }